import React, { useCallback } from "react"
import { Form } from "react-bootstrap"
import { Field } from "react-final-form"
import { valueOrNull } from "@/helpers/formatters"
import { FormFieldNames, fieldViewProps } from "../create_schedule/constants"
import FormEditor from "@/components/FormEditor"

const ScheduleFormField = React.memo(
  ({ name, type, placeholder, disabled, multipleValues, as = "input", ...props }) => {
    const parse = useCallback(
      value => {
        if (name === FormFieldNames.ScheduleNote) {
          return value || ""
        }
        return valueOrNull(value)
      },
      [name]
    )

    const renderField = useCallback(
      ({ input, meta }) => {
        if (as === "editor") {
          return (
            <>
              <FormEditor
                dataTest={props["data-testid"]}
                {...input}
                value={input.value}
                onChange={input.onChange}
                disabled={disabled}
              />
              {meta.touched && meta.error && (
                <Form.Control.Feedback type="invalid" className="mt-1">
                  {meta.error}
                </Form.Control.Feedback>
              )}
            </>
          )
        }

        return (
          <>
            <Form.Control
              dataTest={props["data-testid"]}
              as={as}
              {...input}
              className="v-2"
              placeholder={multipleValues ? "Multiple values" : placeholder}
              disabled={disabled}
              isInvalid={meta.touched && meta.error}
            />
            {meta.touched && meta.error && (
              <Form.Control.Feedback type="invalid" className="mt-1">
                {meta.error}
              </Form.Control.Feedback>
            )}
          </>
        )
      },
      [as, disabled, multipleValues, placeholder, props]
    )

    return (
      <Field name={name} type={type} parse={parse} {...fieldViewProps} {...props}>
        {renderField}
      </Field>
    )
  }
)

ScheduleFormField.displayName = "ScheduleFormField"

export default ScheduleFormField
